import {
  Required,
  DataValidator,
  transformKeys,
  IsString,
} from "@/utils/type-vaildator";
import api from "./api";

export interface AgentPersonalInfoTemplateGetResponse {
  agent_id: string;
  personal_information_template: string;
};


class AgentPersonalInfoTemplateGetData {
  // @Required("personalInformationTemplate cannot be empty")
  @IsString("personalInformationTemplate must be a string")
  personalInformationTemplate: string;
}

const transformAndValidateData = (
  response: AgentPersonalInfoTemplateGetResponse
): AgentPersonalInfoTemplateGetData => {
  const transformedData = transformKeys(response);

  try {
    const data = DataValidator.validateOrThrow(transformedData, AgentPersonalInfoTemplateGetData);
    
    if (!data.personalInformationTemplate) {
      data.personalInformationTemplate = '';
    }

    return data;
  } catch (error) {
    console.error("Knowledge create folder data validation failed:", error.message);
    throw error;
  }
};

/** 获取智能体个人信息模版 */
export const agentPersonalInfoTemplateGet = async (agentId: string) => {
  const res = await api.post<AgentPersonalInfoTemplateGetResponse>('/agent/personal-info-template/get', {
    agent_id: agentId
  });
  const data = transformAndValidateData(res.data);
  return data;
}